module.exports = __webpack_public_path__ + "static/flags/CV-4485124dd3b45fcea216f5738e344d51.gif";